/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RefundMerchantSale_transfer = {
    readonly id: string;
    readonly maybeTransferId: string | null;
    readonly maybeSenderName: string | null;
    readonly maybeSenderMobile: string | null;
    readonly grossAmount: string;
    readonly " $refType": "RefundMerchantSale_transfer";
};
export type RefundMerchantSale_transfer$data = RefundMerchantSale_transfer;
export type RefundMerchantSale_transfer$key = {
    readonly " $data"?: RefundMerchantSale_transfer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RefundMerchantSale_transfer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RefundMerchantSale_transfer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "maybeTransferId",
      "args": null,
      "kind": "ScalarField",
      "name": "transferId",
      "storageKey": null
    },
    {
      "alias": "maybeSenderName",
      "args": null,
      "kind": "ScalarField",
      "name": "senderName",
      "storageKey": null
    },
    {
      "alias": "maybeSenderMobile",
      "args": null,
      "kind": "ScalarField",
      "name": "senderMobile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossAmount",
      "storageKey": null
    }
  ],
  "type": "MerchantSaleEntry",
  "abstractKey": null
};
(node as any).hash = '09a1f610e12ba64857c36f08df653ed1';
export default node;
